"use strict";

exports.__esModule = true;
exports.MODAL_ROOT_PATH = void 0;
var MODAL_ROOT_PATH = '/modal';
exports.MODAL_ROOT_PATH = MODAL_ROOT_PATH;